<template>
 <v-app>
                          <v-content>
   <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Overview Pengeluaran</h3>

                <div class="card-tools">
                  
                  <!--button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah
                  </button-->
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body ">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      
                        <label>Bulan Pengeluaran</label>
                        <v-dialog
                          ref="dialog"
                          v-model="modaltgl"
                          :return-value.sync="tanggal_query"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field style="margin-top:0px;padding-top:0px"
                              v-model="tanggal_query"
                            
                              label=""
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="tanggal_query"
                            type="month"
                            scrollable
                            min="2022-08"
                            :max="dateMax"
                            
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modaltgl = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="ubahTanggalTampil($refs)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <!--download-excel :data="datas"
                      :fields="json_fields"
                      :worksheet="'Pengeluaran '+getBulan(tanggal_query)"
                      :name="'Pengeluaran '+ getBulan(tanggal_query) +'.xls'"
                      >
                          <button type="button" class="btn btn-sm btn-success">
                              <i class="fa fa-file-excel"></i>
                              &nbsp; Download
                          </button>
                    </download-excel-->
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 table-responsive p-0">
                    <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>kategori</th>
                      <th>Budget</th>
                      <!--th>Tanggal Pengeluaran</th-->
                      <th>Realisasi</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="(datas)" v-for="(row, index) in datas" :key="row.id" :class=" row.budget < row.realisasi ? 'text-red' : '' ">
                      <td>{{index+1}}</td>
                      <td>{{ row.kategori_nama }}</td>
                      <td>{{row.budget | toCurrency}}</td>
                      <td>{{row.realisasi | toCurrency}}</td>
                      <td>
                        <a href="#" @click="getDetailData(row.id)" class="ml-2" title="Lihat Keterangan">
                            <i class="fas fa-eye" aria-hidden="true"></i>
                        </a>
                      </td>
                    </tr>
                    <tr v-if="(!datas)" >

                      <td colspan="6" class="text-center"><h3>Data Kosong</h3></td>
                      <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                      <!--td>

                        <a href="#" v-if="row.status == 'ditolak' || row.status == 'pending'" @click="deleteData(row.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td-->
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="2" class="text-center"><h5>Total</h5></th>
                      <th><h5>{{this.total_budget | toCurrency}}</h5></th>
                      <th><h5>{{this.total_realisasi | toCurrency}}</h5></th>
                      <th></th>
                    </tr>
                  </tfoot>
                </table>
                  </div>
                </div>
                
              </div>
              <!-- /.card-body -->
              <!--div class="card-footer">
                  <pagination :data="datas" @pagination-change-page="getResults"></pagination>
              </div-->
            </div>
            <!-- /.card -->
          </div>
        </div>

        <div class="modal fade" id="KeteranganModal" tabindex="-1" role="dialog" aria-labelledby="KeteranganModal" aria-hidden="true" data-backdrop="static" data-keyboard="false" >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Detail Pengeluaran </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                      
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12 table-responsive p-0">
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th>No</th>
                                <th>Jumlah</th>
                                <th>Keterangan</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="(datasDetail)" v-for="(row, index) in datasDetail" :key="row.id">
                                <td>{{index+1}}</td>
                                <td>{{ row.jumlah | toCurrency}}</td>
                                <td>{{ row.keterangan }}</td>
                                
                              </tr>
                              <tr v-if="(!datasDetail)" >

                                <td colspan="3" class="text-center"><h3>Data Kosong</h3></td>
                                <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                                <!--td>

                                  <a href="#" v-if="row.status == 'ditolak' || row.status == 'pending'" @click="deleteData(row.id)">
                                      <i class="fa fa-trash red"></i>
                                  </a>
                                </td-->
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
  
  </v-content>
      
  </v-app>
</template>

<script>
    export default {
        data () {
            return {
                datas : [],
                datasDetail : [],
                menu: false,
                modaltgl: false,
                dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
                total_budget: 0,
                total_realisasi: 0,
            }
        },
        methods: {
          countJumlahnya(){
            Object.entries(this.datas).forEach(([key, val]) => {       
              this.total_budget += parseInt(val.budget);
              this.total_realisasi += parseInt(val.realisasi);
              
            });
          },
          getDetailData(kid){
            this.$Progress.start();
            
            let tahunpaid = this.tanggal_query.substr(0, 4);
            let bulanpaid = this.tanggal_query.substr(-2, 2);
            axios.get("api/keuangan/overviewDetail?kategori_id="+kid+"&tahunpaid="+tahunpaid+"&bulanpaid="+bulanpaid).then(({ data }) => {
              if(data.data.length){
                this.datasDetail = data.data;
              }else{
                this.datasDetail = false;
              }
            });
            $('#KeteranganModal').modal('show');
            this.$Progress.finish();
          },
          getBulan(tanggal){
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
            
            return (bulan[tgltemp.getMonth()] + " " + tahun);
          },
          ubahTanggalTampil(e) {
            e.dialog.save(this.tanggal_query);
            this.loadData();       
           // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
          },
          loadData(){
            if(this.$gate.isAllowed("is_keuangan")){
              this.total_budget = 0;
              this.total_realisasi = 0;
              let tahunpaid = this.tanggal_query.substr(0, 4);
              let bulanpaid = this.tanggal_query.substr(-2, 2);
              axios.get("api/keuangan/overview?tahunpaid="+tahunpaid+"&bulanpaid="+bulanpaid).then(({ data }) => {
                
                if(data.data.length){
                  this.datas = data.data;
                  this.countJumlahnya();
                }else{
                  this.datas = false;
                }
              });
              this.tanggal_tampil = this.getBulan(this.tanggal_query);
            }
          },
        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadData();
            this.$Progress.finish();
            
        }
    }
</script>
<style scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

</style>